import type { CommandProps } from '@fluidx/office-fluid-types';
import { DefaultPresenceColorProvider, Locale, resolveLocale } from '@fluidx/utilities';
import type { IFluidCodeDetails } from '@fluidframework/core-interfaces';
import { getCommandingSurfaceParts } from '@fluidx/host-ux';
import { FluidTokenProvider } from './fluidTokenProvider';
import { generateHostConfig } from './generateHostConfig';
import { getHostContext } from './hostContext/scopeHelpers';
import { getAppStylingProvider } from './getAppStylingProvider';
import { getActionMenuItems } from './getActionMenuItems';
import type { FluidRenderProps } from '../../store/schema/FluidRenderProps';
import type { FluidOwaSource } from 'owa-fluid-validations';
import { getCurrentLanguage } from 'owa-localize';

export function getFluidPropsForRender(
    sessionId: string,
    scenarioName: string,
    scenarioStartTime: number,
    owaSource: FluidOwaSource,
    codeDetails?: IFluidCodeDetails,
    url?: string,
    deleteNode?: () => void,
    customMenuItems?: CommandProps[]
): FluidRenderProps {
    const hostContext = getHostContext(sessionId, scenarioName, scenarioStartTime);
    const stylingProvider = getAppStylingProvider();
    const hostConfig = generateHostConfig(hostContext, owaSource, codeDetails);

    const locale = getCurrentLanguage();
    const fluidLocale: Locale = resolveLocale(locale);

    return {
        tokenProvider: new FluidTokenProvider(),
        presenceColorProvider: new DefaultPresenceColorProvider(),
        hostConfig: hostConfig,
        hostContext: hostContext,
        stylingProvider: stylingProvider,
        menuItems: getActionMenuItems(owaSource, url, deleteNode, customMenuItems),
        commandingSurfaceParts: getCommandingSurfaceParts(
            hostConfig.logger,
            stylingProvider,
            fluidLocale
        ),
    };
}
